<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 dialog-title">Update {{data.itemName}} Status</p>
  </div>
  <div>
    <button [mat-dialog-close]="true" mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<hr>
  <form nz-form (ngSubmit)="onSubmit()" [formGroup]="foodStatusForm">
    <div class="px-4">
      <nz-form-item>
        <div class="w-100">
          <nz-form-label>Food Status</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="status" nzPlaceHolder="Select Status">
              @for (data of statusKeyValue; track data) {
                <nz-option [nzLabel]="data.value" [nzValue]="data.key"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </div>
      </nz-form-item>
    </div>

    <div class="mt-4 d-flex justify-content-end mb-4 me-4">
      <button class="w-25 btn-radius me-2" [mat-dialog-close]="true" nzType="primary" nzGhost nz-button>
        Cancel
      </button>
      <button nz-button nzType="primary" class="w-25 btn-radius">
        Update
      </button>
    </div>
  </form>
